const data = {
  counterText: 'मर्यादित स्लॉट उपलब्ध',
  loading: 'लोड होत आहे',
  next: 'पुढे',
  previous: 'मागील',
  smCounterText: 'मर्यादित स्लॉट बाकी',
};

export default data;
